import { ActionLink } from "@/components/ActionLink";
import { FeaturePanel } from "@/components/FeaturePanel";
import { SectionHeading } from "@/components/SectionHeading";
import { homeHeroActions, homePillars, socialCards } from "@/data/siteContent";

export function HomePage() {
  return (
    <div>
      <section className="px-4 pb-24 pt-14 md:px-8 md:pt-20">
        <div className="mx-auto grid max-w-7xl gap-10 overflow-hidden rounded-[2.5rem] border border-outline/10 bg-surface/80 p-8 shadow-ambient md:grid-cols-[1.2fr_0.8fr] md:p-12">
          <div className="space-y-8">
            <div className="space-y-5">
              <p className="eyebrow">Kevin Kinnett</p>
              <h1 className="font-display text-5xl leading-[1.02] text-text md:text-7xl">
                Software, teaching, and <span className="italic text-primary">visual work</span>
              </h1>
              <p className="max-w-2xl text-lg leading-8 text-muted">
                Aletheia Development is my studio for software consulting, technical education, and the visual projects
                that sit somewhere between engineering and art.
              </p>
            </div>
            <div className="flex flex-wrap gap-4">
              {homeHeroActions.map((action, index) => (
                <ActionLink
                  key={action.label}
                  action={action}
                  variant={index === 0 ? "primary" : "secondary"}
                />
              ))}
            </div>
          </div>
          <div className="relative flex min-h-[24rem] items-end overflow-hidden rounded-[2rem] border border-outline/10 bg-surface-high">
            <img
              src="/assets/home/image-01.webp"
              alt=""
              className="absolute inset-0 h-full w-full object-cover opacity-45"
            />
            <img
              src="/assets/home/screenshot.webp"
              alt=""
              className="relative ml-auto mt-16 w-full max-w-md rounded-tl-[1.5rem] border border-white/10 shadow-ambient"
            />
          </div>
        </div>
      </section>

      <section id="pillars" className="px-4 py-24 md:px-8">
        <div className="mx-auto max-w-7xl space-y-12">
          <SectionHeading
            eyebrow="Three areas"
            title="What the studio is actually for"
            description="The work falls into three parts: building software, teaching what I know, and keeping a home for experiments worth sharing."
          />
          <div className="grid gap-8 md:grid-cols-3">
            {homePillars.map((card) => (
              <FeaturePanel key={card.title} card={card} />
            ))}
          </div>
        </div>
      </section>

      <section className="bg-surface-low px-4 py-24 md:px-8">
        <div className="mx-auto grid max-w-7xl gap-12 md:grid-cols-[0.75fr_1.25fr]">
          <SectionHeading
            eyebrow="Public-facing work"
            title="A place to share work in the open"
            description="Some of this site is for clients, some is for people learning alongside me, and some of it is simply where ongoing work gets archived."
          />
          <div className="grid gap-6 md:grid-cols-2">
            {socialCards.map((card) => (
              <FeaturePanel key={card.title} card={card} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

